import { render, staticRenderFns } from "./UtilitiesTable.vue?vue&type=template&id=6204b7d9&scoped=true"
import script from "./UtilitiesTable.vue?vue&type=script&lang=js"
export * from "./UtilitiesTable.vue?vue&type=script&lang=js"
import style0 from "./UtilitiesTable.vue?vue&type=style&index=0&id=6204b7d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6204b7d9",
  null
  
)

export default component.exports